<template>
  <KaButton id="alerts-button" @click="showAlertMsgs" data-testid="alerts-button">
    <span class="sr-only">Show Alerts</span>
    <div class="relative">
      <IconBell class="size-5" aria-hidden="true" />
      <transition
        enter-active-class="animated-300 fadeIn"
        leave-active-class="animated-300 fadeOut"
      >
        <span
          v-if="messagesNotMuted.length"
          :class="
            cnMerge(
              'absolute -right-1 -top-1.5 grid h-4 min-w-4 place-items-center rounded-full bg-primary-dark px-1 py-0.5 text-xs font-semibold leading-none text-white transition-colors dark:bg-primary dark:text-navy-950',
              isError && 'bg-danger-dark dark:bg-danger',
              isWarning && 'bg-warning-dark dark:bg-warning',
            )
          "
        >
          {{ messagesNotMuted.length > 99 ? '99+' : messagesNotMuted.length }}
        </span>
      </transition>
    </div>
  </KaButton>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import constants from '@/constants';
import EventBus from '@/event-bus';
import { KaButton } from '@/kasten-components';
import type { AlertMessage } from '@/stores/main';
import { cnMerge } from '@/utils';
import IconBell from '~icons/lucide/bell';

const props = defineProps<{
  alertMessages: AlertMessage[];
}>();

function showAlertMsgs() {
  EventBus.$emit('alert-messages-show');
}

const messagesNotMuted = computed(() => props.alertMessages.filter((m) => !m.muted));

const isError = computed(() =>
  messagesNotMuted.value.find((m) => m.level === constants.alertLevel.ERROR),
);

const isWarning = computed(() =>
  messagesNotMuted.value.find((m) => m.level === constants.alertLevel.WARNING),
);
</script>
